import React from 'react';

import {ApplicationCardSkeleton} from '../../../components/common/applications/skeleton/applicationCardSkeleton';

/*
 * Helpers.
 */

export function renderMultiLoadingState() {
  return (
    <>
      <ApplicationCardSkeleton hasButton />
      <ApplicationCardSkeleton hasButton />
      <ApplicationCardSkeleton hasButton />
      <ApplicationCardSkeleton hasButton />
      <ApplicationCardSkeleton hasButton />
      <ApplicationCardSkeleton hasButton />
      <ApplicationCardSkeleton hasButton />
      <ApplicationCardSkeleton hasButton />
      <ApplicationCardSkeleton hasButton />
      <ApplicationCardSkeleton hasButton />
      <ApplicationCardSkeleton hasButton />
      <ApplicationCardSkeleton hasButton />
      <ApplicationCardSkeleton hasButton />
    </>
  );
}
